import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Row extends Component {
	clicked() {
		this.props.clicked(this.props.row);
	}
	checked() {
		this.props.checked(this.props.row);
	}
	getURL() {
		var url = "";
		if(this.props.stack!==undefined && this.props.stack.length) {
			for(var i=0;i<this.props.stack.length;i++) {
				url += "/"+this.props.stack[i];
			}
		}
		return url;
	}
	render() {
		var url = this.getURL();

		var checked = false;
		if(this.props.row.checked) checked = true;

		var src = "/images/0_t.jpg";
		var filename = "page.html";

		if(!this.props.row.group) {
			if(this.props.row.hasimage) src = "/images/"+this.props.row.id+"_t.jpg";
			filename = this.props.row.title.toLowerCase().replace(/'/g,"").replace(/[\W_]+/g,"-")+".html";
			return (
				<div className="row">
					<img src={src} width="50" height="50" alt={ this.props.row.title } />
	
					<label className="check">
					  <input type="checkbox" checked={checked} onChange={this.checked.bind(this)}/>
					  <div className="box"></div>
					</label>

					<Link to={url+"/"+this.props.row.id+"/"+filename} className="row-inner" onClick={this.clicked.bind(this)}>
						{ this.props.row.title }
					</Link>
				</div>
			);
		} else {
			if(this.props.row.id!==0) src = "/images/"+this.props.row.id+".jpg";
			filename = this.props.row.title.toLowerCase().replace(/'/g,"").replace(/[\W_]+/g,"-")+".html";

			return (
				<Link to={url+"/"+this.props.row.id+"/"+filename} className="row big" onClick={this.clicked.bind(this)}>
					<img src={src} width="60" height="60" alt={ this.props.row.title } />
					<div className="title">{ this.props.row.title }</div>
					<div className="percent">{ this.props.row.percent }%</div>
					<div className="caret"><span className="chevron right"></span></div>
				</Link>
			);
		}
	}


}



export default Row;



// WEBPACK FOOTER //
// ./src/Row.js